import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4f5fda0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://assets.qiandaocdn.com/admin-upload/1adfc596d1a7b0f8f3a8c316c34fffc8.png!lfit_w1080_jpg",
  class: "background",
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.qiandaocdn.com/admin-upload/eb4dbd64b1410364fb0db24f8bae0509.png",
    alt: "",
    class: "logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.qiandaocdn.com/admin-upload/49df54055457674b3f4ef857f3aadf54.png",
    alt: "",
    class: "title"
  })
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { invokeAppByYYB } from "@/utils/mob";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const isWxBrowser = ref(false);
const isWxBrowserFn = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClick);
});

isWxBrowser.value = isWxBrowserFn();

function handleClick() {
  if (isWxBrowser.value) {
    router.push(`/`);
    return;
  }
  invokeAppByYYB({
    targetPath: "hybrid",
    params: {
      url: "https://events.linjieapp.com/yearly-report-2025-linjie?isShowNavigationBar=false",
      linjieEnv: false,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}
}

})